import type { RouteState } from "./types";

function parseHash(): RouteState {
  const hash = window.location.hash.replace(/^#/, "");
  const [path, queryString] = hash.split("?");
  const query = new URLSearchParams(queryString || "");

  switch (path) {
    case "/admin/users":
      return { name: "admin-users" };
    case "/projects/declaration":
      return {
        name: "project-declaration",
        projectId: query.get("id") || undefined,
        source: query.get("from") === "basic-info" ? "basic-info" : undefined,
      };
    case "/projects/receiving":
      return { name: "project-receiving", projectId: query.get("id") || undefined };
    case "/projects/inspection-items":
      return { name: "inspection-items", projectId: query.get("id") || undefined };
    case "/projects/inspection-item":
      return {
        name: "inspection-item-detail",
        projectId: query.get("projectId") || undefined,
        itemId: query.get("itemId") || undefined,
      };
    case "/projects/inspection-subitem":
      return {
        name: "inspection-subitem-edit",
        projectId: query.get("projectId") || undefined,
        itemId: query.get("itemId") || undefined,
        subitemId: query.get("subitemId") || undefined,
      };
    case "/projects/new":
      return { name: "new-project" };
    case "/projects/home":
      return { name: "project-home", projectId: query.get("id") || undefined };
    case "/projects/basic-info":
      return { name: "project-basic-info", projectId: query.get("id") || undefined };
    case "/projects/overview":
      return { name: "project-overview", projectId: query.get("id") || undefined };
    case "/projects/preview":
      return { name: "project-preview", projectId: query.get("id") || undefined };
    case "/projects/report-preview":
      return { name: "project-report-preview", projectId: query.get("id") || undefined };
    case "/projects/record-preview":
      return { name: "project-record-preview", projectId: query.get("id") || undefined };
    case "/projects":
      return { name: "project-list" };
    case "/login":
    default:
      return { name: "login" };
  }
}

export function getCurrentRoute(): RouteState {
  return parseHash();
}

export function navigate(hash: string): void {
  if (window.location.hash === hash) {
    window.dispatchEvent(new HashChangeEvent("hashchange"));
    return;
  }
  window.location.hash = hash;
}
